import { decryptMessage } from "app/services/CommonService";
import { jwtDecode } from "jwt-decode";
const gstValue = 15.25 / 100;
const tdsValue = 2 / 100;
const getToken = () => {
  if (typeof window !== "undefined") {
    return JSON.parse(sessionStorage.getItem("jwt_token")) || null;
  }
  return null;
};

const verifyAndExtractName = () => {
  try {
    const token = getToken();
    if (token !== null) {
      const decoded = jwtDecode(decryptMessage(token));
      return (
        decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ||
        null
      );
    }
    return null;
  } catch (error) {
    // console.error("Invalid token:", error);
    return null;
  }
};
const normalizeRole = (role) => {
  if (!role) return "ADMIN";

  const requiredRole = role.toUpperCase().trim();

  switch (requiredRole) {
    case "ADMIN":
      return "ADMIN";

    case "DISTRIBUTOR":
      return "DISTRIBUTOR";

    case "MERCHANT":
      return "MERCHANT";

    case "MASTER ADMIN":
      return "MASTER_ADMIN";

    case "API USER":
      return "API_USER";

    case "SUPPLIER":
      return "SUPPLIER";

    case "OPERATION":
      return "OPERATION";

    case "SALES MANAGER":
      return "SALES_MANAGER";

    case "JR ACCOUNTS":
      return "JR_ACCOUNTS";

    case "SR ACCOUNTS":
      return "SR_ACCOUNTS";

    case "TICKETING":
      return "TICKETING";

    case "TICKETING REFUND":
      return "TICKETING_REFUND";

    case "AGENT SUPPORT":
      return "AGENT_SUPPORT";

    case "TEAMLEADER":
      return "TEAMLEADER";

    case "BACKOFFICESUPPORT":
      return "BACKOFFICE_SUPPORT";

    case "ACCOUNTS":
      return "ACCOUNTS";

    case "MANAGER":
      return "MANAGER";

    case "EXECUTIVE SALES":
      return "EXECUTIVE_SALES";

    case "ACCOUNTS MANAGER":
      return "ACCOUNTS_MANAGER";

    case "SUPER ADMIN":
      return "SUPER_ADMIN";

    case "SUB-MERCHANT":
      return "SUB_MERCHANT";

    case "NONE":
      return "NONE";

    default:
      return role;
  }
};
const getTdsCommissionCal = (commission) => {
  const gstComm = parseFloat((commission * gstValue).toFixed(2)) ?? 0;
  const originalCommWithGSt =
    parseFloat((commission - gstComm).toFixed(2)) ?? 0;
  const tds = parseFloat((originalCommWithGSt * tdsValue).toFixed(2)) ?? 0;

  return {
    originalCommWithoutGst: parseFloat(commission).toFixed(2) ?? 0,
    originalCommWithGSt,
    gstComm,
    tds,
  };
};

export { verifyAndExtractName, getToken, normalizeRole, getTdsCommissionCal };
